import React, { Component } from 'react'
import { LinkContainer } from 'react-router-bootstrap'
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavLink } from 'reactstrap'
import { withRouter } from 'react-router'
import styled from 'styled-components'
import LOGO from '../image/header-logo.png'
// import LOGO from '../image/logo (2).png'
import '../style/navbar-custom.less'
import { BaseURL } from '../helpers'
const _package = require('../../package.json')
const store_name = `useryaa-${_package.version}`

const FontSize = styled.div`
	font-size: 16px;
`
const SystemName = styled.div`
	font-size: 20px;
	color: #616161;
`
class NavMenu extends Component {
	displayName = NavMenu.name

	constructor(props) {
		super(props)

		this.toggle = this.toggle.bind(this)
		this.state = {
			isOpen: false,
			userType: 'normal',
			userName:''
		}

		var element = document.getElementById('main-body')
		element.classList.remove('login-body')
		element.classList.add('content-body')
	}

	componentDidMount = () => {
		let user = JSON.parse(localStorage.getItem(`${store_name}`))

		if (user) {
			this.setState({ userType: user.userType, userName: user.username })
		}
	}

	toggle() {
		this.setState({
			isOpen: !this.state.isOpen,
		})
	}

	render() {
		return (
			<div>
				<Navbar color="#fff" className="bg-nav" expand="md" style={{ padding: 0 }}>
					<LinkContainer to={`${BaseURL}/`}>
						<NavbarBrand>
							{/* <SystemName>YAA System</SystemName> */}
							<div className="logo">
								<img src={LOGO} alt="yuanta" className="logo-img" />{' '}
							</div>
						</NavbarBrand>
					</LinkContainer>
					<NavbarToggler onClick={this.toggle} />
					<Collapse isOpen={this.state.isOpen} navbar>
						<Nav className="ml-auto" navbar>
							<LinkContainer to={`${BaseURL}/`} exact>
								<NavLink>
									<FontSize>หน้าหลัก</FontSize>
								</NavLink>
							</LinkContainer>
							{this.state.userName.indexOf('R') === -1 && (
								<LinkContainer to={`${BaseURL}/listcustomer`}>
									<NavLink>
										<FontSize>ลูกค้า</FontSize>
									</NavLink>
								</LinkContainer>
							)}
							{this.state.userType.indexOf('corporation') > -1 ? (
								<LinkContainer to={`${BaseURL}/organization-balance`}>
									<NavLink>
										<FontSize>การเงิน</FontSize>
									</NavLink>
								</LinkContainer>
							) : (
								<LinkContainer to={`${BaseURL}/balance`}>
									<NavLink>
										<FontSize>การเงิน</FontSize>
									</NavLink>
								</LinkContainer>
							)}
							{this.state.userType.indexOf('corporation') > -1 && (
								<LinkContainer to={`${BaseURL}/Organization`}>
									<NavLink>
										<FontSize>จัดการลูกข่าย</FontSize>
									</NavLink>
								</LinkContainer>
							)}
							<LinkContainer to={`${BaseURL}/profile`}>
								<NavLink>
									<FontSize>โปรไฟล์</FontSize>
								</NavLink>
							</LinkContainer>
							<LinkContainer to={`${BaseURL}/login`}>
								<NavLink>
									<FontSize>ออกจากระบบ</FontSize>
								</NavLink>
							</LinkContainer>
						</Nav>
					</Collapse>
				</Navbar>
			</div>
		)
	}
}

export default withRouter(NavMenu)
